import React from 'react';

// The "how it works" journey, drawn rather than typed. These were emoji
// (📅 🚚 🏢 📦 🛣️ 🏠), which render as a different picture on every
// platform — Apple's van is not Google's van is not Windows' van — and cannot
// take a brand colour. Inline SVG on `currentColor` gives one consistent
// drawing that inherits the chip's colour in all three themes, the same
// reasoning as `TileIcons.tsx` (DESIGN_LANGUAGE.md Phase 4.4 item 5).

type IconProps = { className?: string };

function Svg({
  className,
  children,
}: IconProps & { children: React.ReactNode }): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/** Calendar — pick your date. */
export function CalendarIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <path d="M3 10h18M8 3v4M16 3v4" />
      <path d="M8 14h3" />
    </Svg>
  );
}

/** Van — we collect. */
export function VanIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <path d="M2 7.5h11v9H2z" />
      <path d="M13 10.5h4l4 3.5v2.5h-8z" />
      <circle cx="7" cy="18" r="1.9" />
      <circle cx="17.5" cy="18" r="1.9" />
    </Svg>
  );
}

/** Warehouse under a shield — stored securely. */
export function WarehouseIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <path d="M3 10.5 12 5l9 5.5V20H3z" />
      <path d="M9 20v-5.5h6V20" />
      <path d="M12 8.6v2.4" />
    </Svg>
  );
}

/** Open box — ready when you want it back. */
export function OpenBoxIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <path d="M3.5 9.5 12 5.5l8.5 4v9L12 22.5l-8.5-4z" />
      <path d="m3.5 9.5 8.5 4 8.5-4M12 13.5v9" />
      <path d="M8.5 3.5 12 5.5l3.5-2" />
    </Svg>
  );
}

/** Road — in transit. */
export function RouteIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <path d="M8.5 3 6 21M15.5 3 18 21" />
      <path d="M12 4.5v3M12 10.5v3M12 16.5v3" />
    </Svg>
  );
}

/** House — delivered to the door. */
export function HomeIcon(props: IconProps): JSX.Element {
  return (
    <Svg {...props}>
      <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
      <path d="M9.5 21v-6h5v6" />
    </Svg>
  );
}
